import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { CONSENT_EVENT, analyticsAllowed, hasPrivacySignal, readAnalyticsConsent, saveAnalyticsConsent } from "@/lib/analyticsConsent";
import { stopAnalytics } from "@/lib/privateAnalytics";

export const AnalyticsPreferences = () => {
  const [choice, setChoice] = useState(readAnalyticsConsent);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    const sync = () => setChoice(readAnalyticsConsent());
    window.addEventListener(CONSENT_EVENT, sync);
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener(CONSENT_EVENT, sync);
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);
  const choose = next => {
    setError("");
    setMessage("");
    const saved = saveAnalyticsConsent(next);
    if (!analyticsAllowed()) stopAnalytics();
    if (!saved) setError("We couldn’t save your preference. Analytics is off for this visit.");
    else setMessage(next === "denied" ? "Analytics is off. Your preference is saved in this browser." : "Analytics is on. Your preference is saved in this browser.");
  };
  return <section className="ph-no-capture mt-10 border-y border-[color:var(--line)] py-8" aria-labelledby="analytics-preferences-heading" data-testid="analytics-preferences-panel">
    <h2 id="analytics-preferences-heading" className="font-display text-lg" data-testid="analytics-preferences-title">Page-view analytics</h2>
    <p className="mt-4 text-sm leading-relaxed" data-testid="analytics-preferences-description">PostHog page-view analytics is on by default. You can turn it off here without affecting access to the site or its forms. Session replay and automatic form-content tracking are disabled.</p>
    <p className="mt-5 text-sm" role="status" data-testid="cookie-settings-status">Analytics: <strong>{choice === "denied" ? "Off" : choice === "default" ? "On (default)" : "On"}</strong></p>
    {hasPrivacySignal() && <p className="mt-3 text-sm" data-testid="analytics-gpc-notice">Global Privacy Control is on in your browser. Analytics stays off.</p>}
    <div className="mt-6 flex flex-wrap gap-3">
      <Button variant="outline" className="min-h-11 rounded-none border-[#171717]" onClick={() => choose("denied")} data-testid="analytics-reject-button">Turn off analytics</Button>
      <Button variant="outline" className="min-h-11 rounded-none border-[#171717]" disabled={hasPrivacySignal()} onClick={() => choose("granted")} data-testid="analytics-accept-button">Turn on analytics</Button>
    </div>
    {message && <p className="mt-5 text-sm" role="status" data-testid="analytics-preferences-confirmation">{message}</p>}
    {error && <p className="mt-5 text-sm text-red-800" role="alert" data-testid="analytics-consent-error">{error}</p>}
  </section>;
};